module.exports = __webpack_public_path__ + "img/pro_s1_icon2.e59e86e0.png";